import type { Input } from '@builder.io/sdk';

const faqPageFields = [
  {
    name: 'faqPages',
    type: 'list',
    subFields: [
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'faqPage',
        type: 'list',
        subFields: [
          {
            name: 'heading',
            type: 'string',
          },
          {
            name: 'type',
            type: 'string',
            enum: ['link', 'faqs'],
            defaultValue: 'link',
          },
          {
            name: 'link',
            type: 'url',
          },
          {
            name: 'faqs',
            type: 'list',
            showIf: "options.get('type') === 'faqs'",
            subFields: [
              {
                name: 'question',
                type: 'string',
              },
              {
                name: 'answer',
                type: 'richText',
              },
            ],
          },
        ],
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const faqPageConfig = {
  name: 'Faq Page',
  inputs: faqPageFields,
};

export type FAQPageProps = GenerateBuilder<typeof faqPageFields>;

export default faqPageConfig;
